<app-base-payments-for-confirm
  [getTableDataApiMethodName]="getTableDataApiMethodName"
  [pageTitle]="pageTitle"
  pageId="reseller-payments-for-confirm"
>
</app-base-payments-for-confirm>
